const StarsIcon = () => {
    return (
        <i className="fa-solid fa-stars"></i>
    )
}

export default StarsIcon;